import { Note } from 'src/services/api/notesApi';

import { NotesListItem } from './NotesListItem';

export const NotesList = ({
  notes,
  onClick,
}: {
  notes: Note[];
  onClick: (note: Note) => void;
}) => {
  return (
    <div className="w-full">
      {notes.map((note) => (
        <NotesListItem
          key={note.id}
          note={note}
          onClick={() => onClick(note)}
        />
      ))}
    </div>
  );
};
